import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { FeatureLayout, ExpandableFeatureLayout } from '@lendica/components';
import { useAccountDataContext } from './AccountData';
import { useContainerWidth } from '@lendica/hooks';

export const AccountContainer = ({ children }: { children: ReactNode }) => {
    const { isNarrow } = useContainerWidth();
    const { isLoading } = useAccountDataContext();

    return (
        <ExpandableFeatureLayout loading={isLoading}>
            <Box
                sx={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    boxSizing: 'border-box',
                }}
            >
                <Box
                    sx={theme => ({
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        px: 2,
                        py: 1,
                        borderBottom: `1px solid ${theme.palette.divider}`,
                    })}
                >
                    <Typography variant="subtitle1">Account</Typography>
                </Box>
                <Box
                    sx={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        flexDirection: isNarrow ? 'column' : 'row',
                        gap: isNarrow ? 0 : 4,
                    }}
                >
                    {children}
                </Box>
            </Box>
            {/* <Box sx={{ px: 6, py: 2 }}>
                <Box
                    sx={{
                        mt: 1,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Typography variant="subtitle1">Account</Typography>
                </Box>
            </Box>
            {children} */}
        </ExpandableFeatureLayout>
    );
};
